<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9; display: none;">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div
                  class="col d-flex align-items-start justify-content-between"
                >
                  <h3 class="mb-0">Explorador de ventas</h3>
                </div>
              </div>
            </div>

            <div
              class="card-body pt-3 pb-0 mb-4 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <!-- <base-input v-model="filterText" inputClasses="input-group-alternative form-control-sm"
                  class="mb-0 mr-3" placeholder="Buscar" @input="onFilterTextBoxChanged" />
                <base-button v-if="showSearchDocNumBtn" @click="() => $router.push('/invoice/' + filterText)" size="sm">
                  Buscar
                </base-button> -->

                <base-dropdown v-if="currentCollection">
                  <base-button
                    size="sm"
                    slot="title"
                    type="secondary"
                    class="dropdown-toggle"
                  >
                    {{ currentCollection.label }}
                  </base-button>
                  <button
                    class="dropdown-item"
                    v-for="(collection, index) in collections"
                    v-bind:key="index"
                    @click="
                      currentCollection = collection;
                      skip = 0;
                      getSales();
                    "
                  >
                    {{ collection.label }}
                  </button>
                </base-dropdown>
              </div>
            </div>
            <ag-grid-vue
              v-bind="agSales"
              @grid-ready="onGridReady"
              @cell-edit-request="onCellEditRequest"
              @cell-clicked="handleClick"
              style=" height: 65vh;"
              class="ag-theme-alpine"
            />
            <div
              class="d-flex align-items-center w-100 justify-content-end text-sm px-4 font-weight-light mt-2 mb-5"
            >
              <span class="mr-4"
                ><b>{{ skip + 1 }}</b> a <b>{{ skip + 20 }}</b></span
              >
              <div class="d-flex align-items-center">
                <div
                  class="p-1 mr-3"
                  style="cursor: pointer;"
                  @click="skipChange(skip - 20)"
                  v-if="skip >= 20"
                >
                  <i class="fas fa-angle-left"></i>
                </div>
                <span class="mr-3"
                  >Página <b>{{ skip + 1 }}</b></span
                >
                <div
                  class="p-1"
                  style="cursor: pointer;"
                  @click="skipChange(skip + 20)"
                >
                  <i class="fas fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--9" style="margin-top:-9; display: flex; align-items: center; justify-content: center;">
      <div class="card" style="padding: 64px 0px; display: flex; width: 100%; box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2);
      align-items: center; justify-content: center; flex-direction: column; gap: 12px;">
        <img
          style="max-width: 700px;"
          src="https://firebasestorage.googleapis.com/v0/b/canplast-mx.appspot.com/o/graphic_resources%2Fnew_console.svg?alt=media&token=f2cd7d5b-c94f-4ba2-a349-7902fa2c5740"
        />
        <span style="font-size: 18px; font-weight: 600;">
          Este modulo evolucionó a una consola más segura y moderna
        </span>
        <a href="https://consola-v2.canplast.net/docs-venta/explorador-ventas/pedidos" target="_blank" style="font-size: 18px; font-weight: 700; color: #E63840; text-decoration: underline; cursor: pointer;" >Conoce nuestro nuevo explorador de ventas <i style="margin-left: 6px;" class="fas fa-external-link-alt"></i></a>
      </div>
    </div>

    <b-modal
      hide-footer
      size="md"
      title="Stock"
      v-model="showItemStock"
      bodyClass="p-0"
    >
      <div v-if="currentItem" class=" modal-body mt-n3 py-0">
        <h3>{{ currentItem.ItemCode }}</h3>
        <h5 class="text-muted">{{ currentItem.ItemDescription }}</h5>
        <ag-grid-vue
          v-bind="agStock"
          @grid-ready="onGridReadyStock"
          style="height:70vh; min-height: 400px;"
          class="ag-theme-alpine mb-5"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import axios from "axios";
import BaseLoader from "@/components/BaseLoader.vue";
import warehouses from "@/data/warehouses.json";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import Formats from "@/mixins/Formats";

export default {
  mixins: [Formats],
  components: {
    AgGridVue,
    BaseLoader,
  },
  data() {
    return {
      collections: [
        {
          collection: "Orders",
          label: "Pedidos",
          names: ["Orders", "Orders/DocumentLines"],
        },
        {
          collection: "DeliveryNotes",
          label: "Entregas",
          names: ["DeliveryNotes", "DeliveryNotes/DocumentLines"],
        },
        {
          collection: "Quotations",
          label: "Cotizaciones",
          names: ["Quotations", "Quotations/DocumentLines"],
        },
      ],
      filteredWarehouses: [
        "MEX-02",
        "CUU-02",
        "CUU-01",
        "GDL-02",
        "MTY-02",
        "MID-02",
        "QRO-02",
      ],
      gridApi: null,
      salesPersonOptions: null,
      showSearchDocNumBtn: null,
      filterText: null,
      skip: 0,
      currentCollection: null,
      agSales: {
        rowData: null,
        columnDefs: [
          {
            field: "DocNum",
            headerName: "DocNum",
            width: 90,
          },
          {
            field: "LineNum",
            headerName: "LineNum",
            width: 80,
            type: "rightAligned",
          },
          {
            field: "CardName",
            headerName: "Cliente",
            width: 280,
          },
          {
            field: "ItemCode",
            headerName: "Item",
            width: 200,
          },
          {
            field: "Quantity",
            headerName: "Cantidad",
            width: 80,
            type: "rightAligned",
            valueFormatter: ({ value }) => this.numberFormat(value),
          },
          {
            field: "RemainingOpenInventoryQuantity",
            headerName: "Open Qty",
            width: 80,
            type: "rightAligned",
            valueFormatter: ({ value }) => this.numberFormat(value),
          },
          {
            // U_DirectShipping edition only in Orders Filter
            field: "U_DirectShipping",
            headerName: "Direct Shipp",
            width: 100,
            editable: () => this.currentCollection.collection === "Orders",
            cellEditor: "agSelectCellEditor",
            singleClickEdit: true,
            cellEditorParams: {
              values: [
                null,
                "MEX-02",
                "CUU-02",
                "CUU-01",
                "GDL-02",
                "MTY-02",
                "MID-02",
                "QRO-02",
              ],
            },
            valueFormatter: (params) => {
              return (
                params.value ||
                (this.currentCollection.collection === "Orders"
                  ? "Editar..."
                  : "")
              );
            },
            cellClass: (params) => {
              if (this.currentCollection.collection === "Orders") {
                return params.value
                  ? "ag-clickable-cell"
                  : "ag-clickable-cell text-light";
              } else {
                return null;
              }
            },
          },
          {
            field: "WarehouseCode",
            headerName: "Almacén",
            width: 80,
          },
          {
            field: "DocDate",
            headerName: "DocDate",
            width: 100,
          },
          {
            field: "DocDueDate",
            headerName: "Vencimiento",
            width: 100,
          },
          {
            field: "ShipDate",
            headerName: "ShipDate",
            width: 100,
          },
          {
            field: "LineTotal",
            headerName: "LineTotal",
            width: 120,
            valueFormatter: ({ value }) => this.currencyFormat(value),
            type: "numericColumn",
          },
          {
            field: "SalesPersonCode",
            headerName: "Vendedor",
            width: 140,
          },
          {
            field: "FreeText",
            headerName: "FreeText",
            width: 120,
          },
          {
            colId: "stock",
            headerName: "Stock",
            width: 120,
            valueFormatter: () => "Ver Stock",
            cellClass: "ag-clickable-cell text-blue font-weight-bold",
          },
        ],
        defaultColDef: {
          sortable: false,
          resizable: true,
          cellDataType: false,
          // filter: true,
          // floatingFilter: false,
          suppressHeaderMenuButton: true,
        },
        readOnlyEdit: true,
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        singleClickEdit: true,
        stopEditingWhenCellsLoseFocus: true,
        localeText: AG_GRID_LOCALE_ES,
      },

      agStock: {
        rowData: null,
        columnDefs: [
          {
            field: "WarehouseCode",
            headerName: "Almacén",
          },
          {
            field: "InStock",
            headerName: "Stock",
            width: 80,
            type: "rightAligned",
            valueFormatter: ({ value }) => this.numberFormat(value),
          },
        ],
        defaultColDef: {
          resizable: false,
          suppressHeaderMenuButton: true,
        },
        loadingOverlayComponent: "BaseLoader",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        localeText: AG_GRID_LOCALE_ES,
        alwaysShowVerticalScroll: true,
      },
      showItemStock: false,
      currentItem: null,
      filterWhse: null,
    };
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    this.warehouses = warehouses;
    axios
      .get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
        this.getSales(0); //Orders
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },
    onGridReadyStock(params) {
      params.api.sizeColumnsToFit();
    },
    getSales(collectionIndex) {
      this.agSales.rowData = null;
      this.gridApi.showLoadingOverlay();
      if (collectionIndex || collectionIndex === 0) {
        this.currentCollection = this.collections[collectionIndex];
      }
      axios
        .get(
          `/api/sales_explorer/${this.currentCollection.collection}?skip=${
            this.skip
          }`
        )
        .then((res) => {
          this.agSales.rowData = res.data.value.map((x) => {
            let salesPerson = this.salesPersonOptions.find(
              (y) =>
                y.SalesEmployeeCode ===
                x[this.currentCollection.names[1]].SalesPersonCode
            );
            return {
              DocEntry: x[this.currentCollection.names[0]].DocEntry,
              DocNum: x[this.currentCollection.names[0]].DocNum,
              LineNum: x[this.currentCollection.names[1]].LineNum,
              CardName: x[this.currentCollection.names[0]].CardName,
              CardCode: x[this.currentCollection.names[0]].CardCode,
              ItemCode: x[this.currentCollection.names[1]].ItemCode,
              ItemDescription:
                x[this.currentCollection.names[1]].ItemDescription,
              Quantity: x[this.currentCollection.names[1]].Quantity,
              RemainingOpenInventoryQuantity:
                x[this.currentCollection.names[1]]
                  .RemainingOpenInventoryQuantity,
              U_DirectShipping:
                x[this.currentCollection.names[1]].U_DirectShipping,
              WarehouseCode: x[this.currentCollection.names[1]].WarehouseCode,
              DocDate: x[this.currentCollection.names[0]].DocDate,
              DocDueDate: x[this.currentCollection.names[0]].DocDueDate,
              ShipDate: x[this.currentCollection.names[1]].ShipDate,
              LineTotal: x[this.currentCollection.names[1]].LineTotal,
              FreeText: x[this.currentCollection.names[1]].FreeText,
              SalesPersonCode: salesPerson ? salesPerson.SalesEmployeeName : "",
            };
          });
          this.gridApi.hideOverlay();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleClick({ data, colDef }) {
      if (colDef.colId === "stock") {
        this.currentItem = data;
        this.showItemStock = true;
        axios
          .get(`api/items_stock/${data.ItemCode}`)
          .then((result) => {
            this.agStock.rowData =
              result.data.value[0].ItemWarehouseInfoCollection;
          })
          .catch((error) => {
            this.$swal("Error", error, "error");
          });
      }
    },
    onFilterTextBoxChanged() {
      if (this.filterText && /^[0-9]+$/.test(this.filterText)) {
        this.showSearchDocNumBtn = true;
      } else {
        this.showSearchDocNumBtn = false;
      }
    },
    skipChange(skip) {
      this.agSales.rowData = null;
      this.skip = skip;
      this.getSales();
    },
    onCellEditRequest(params) {
      if (this.currentCollection.collection === "Orders") {
        const json = {
          doc_entry: params.data.DocEntry,
          collection: this.currentCollection.names[0],
          document_lines: [
            {
              LineNum: params.data.LineNum,
              ItemCode: params.data.ItemCode,
              U_DirectShipping: params.newValue,
            },
          ],
        };
        console.log("JSON", json);

        axios
          .patch(`api/sales_explorer`, json)
          .then((result) => {
            console.log("🟦 PATCH RES", result);
            if (result.data.error) {
              this.$swal("Error", result.data.error.message.value, "error");
            } else {
              this.$swal(
                "",
                "Se ha actualizado el campo U_DirectShipping correctamente",
                "success"
              );
              this.getSales();
            }
          })
          .catch((error) => {
            this.$swal("Error", error, "error");
          });
      }
    },
  },
};
</script>

<style>
.ag-clickable-cell {
  cursor: pointer !important;
}
.ag-clickable-cell:hover {
  background: #e9ecef !important;
}
</style>
